module.exports = __webpack_public_path__ + "img/cache_close.0459bffa.svg";